import { render } from "./ChatPage.vue?vue&type=template&id=3e6cfc31"
import script from "./ChatPage.vue?vue&type=script&lang=js"
export * from "./ChatPage.vue?vue&type=script&lang=js"

import "./ChatPage.vue?vue&type=style&index=0&id=3e6cfc31&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__